import React from 'react';
import * as Filtering from '../../shared/Filtering';
import { APITypes } from '../../../primary-record-types';
import { getIntl } from '../../../utils/intl';

const intl = getIntl('CareTeamMemberTypeFilter', {
    active: 'Active',
    inactive: 'Inactive',
    title: 'Status',
    all: 'All',
});

export type ActiveStatus = 'active' | 'inactive' | 'all';

export type CareTeamMemberActiveFilterValue = ActiveStatus;

export type CareTeamMemberActiveFilterOwnProps = {
    value: CareTeamMemberActiveFilterValue;
    onChange: (value: CareTeamMemberActiveFilterValue) => void;
    allCareTeamMembers: APITypes.medicalProfileService.CareTeamMemberDetails[];
};

export type CareTeamMemberActiveFilterProps = CareTeamMemberActiveFilterOwnProps;

export const applyActiveFilter = (
    careTeamMembers: APITypes.medicalProfileService.CareTeamMemberDetails[],
    filterValue: CareTeamMemberActiveFilterValue,
) => {
    return careTeamMembers.filter((member) => {
        if (filterValue === 'all') return true;

        const isInactive = member.metadata.isActive === false;
        return (isInactive ? 'inactive' : 'active') === filterValue;
    });
};

const CareTeamMemberActiveFilter: React.FC<CareTeamMemberActiveFilterProps> = ({
    value,
    onChange,
    allCareTeamMembers,
}) => {
    const getCount = (type: CareTeamMemberActiveFilterValue) => {
        if (type === 'all') return allCareTeamMembers.length;

        return applyActiveFilter(allCareTeamMembers, type).length;
    };

    const optionValues = ['all', 'active', 'inactive'] as const;
    return (
        <Filtering.SelectFilter
            value={value}
            onChange={(value) => onChange(value as ActiveStatus)}
            onClear={value !== 'all' ? () => onChange('all' as ActiveStatus) : undefined}
            options={optionValues.map((value) => ({
                value,
                label: intl(value),
                count: getCount(value),
            }))}
            title={intl('title')}
        />
    );
};

export default React.memo(CareTeamMemberActiveFilter);
